const modules = {
  register: {
    insurances: true,
    favorites: process.env.NODE_ENV === 'development' ? false : true,
  },
  drawer: {
    partners: true,
    emergencyPetCareRelay: true,
  },
  contact: {
    liveChat: true,
  },
  others: {
    ThirtyMillionsFriends: true,
    emergencyPetCareRelay: true,
  },
  missingImages: false,
}

export default modules
